import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface RPNEvolutionData {
    epoch: number;
    date: string;
    totalRPN: number;
    avgRPN: number;
    name: string;
}

interface RPNEvolutionChartProps {
    data: RPNEvolutionData[];
}

const RPNEvolutionChart: React.FC<RPNEvolutionChartProps> = ({ data }) => {
    return (
        <div className="w-full h-[300px] bg-card rounded-lg p-4 border border-border">
            <h3 className="text-lg font-semibold mb-4 text-text-primary">Risk Priority Number (RPN) Evolution</h3>
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" opacity={0.3} />
                    <XAxis
                        dataKey="name"
                        stroke="var(--color-text-secondary)"
                        tick={{ fontSize: 10 }}
                        interval={0}
                        angle={-15}
                        textAnchor="end"
                        height={50}
                    />
                    <YAxis stroke="var(--color-text-secondary)" />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'var(--color-card)',
                            borderColor: 'var(--color-border)',
                            color: 'var(--color-text-primary)'
                        }}
                    />
                    <Area
                        type="monotone"
                        dataKey="totalRPN"
                        stroke="var(--color-primary)"
                        fill="var(--color-primary)"
                        fillOpacity={0.2}
                        name="Total RPN"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
};

export default RPNEvolutionChart;
